import { removeTokens } from "../../storage/user";

export const logoutHandler = () => {
  removeTokens();
  window.location.href = "/auth/login";
};
